module.exports = __webpack_public_path__ + "fonts/frame_137_1.svg";